import { create } from "zustand";

import { defaultValues } from "./components/search-form/constants";
import { SearchFormValuesProps } from "./components/search-form/types";

type State = {
  formValues: SearchFormValuesProps;
};

type Action = {
  updateFormValues: (val: State["formValues"]) => void;
};

export const useChartStore = create<Action & State>((set) => ({
  formValues: defaultValues,
  updateFormValues: (val) => set({ formValues: val }),
}));
